import React, { useEffect, useState, useRef } from 'react';
import Banner from '../../assets/images/products/banner1.png'
import BannerMobile from '../../assets/images/banner-mobile.png'
import Ranking from '../../assets/icons/ranking.svg'
import Task from '../../assets/icons/task.svg'
import Security from '../../assets/icons/security.svg'
import { SearchBanner, imgBaseUrl2, getShopBySearch } from '../../utils/api';
import Carousel from 'react-bootstrap/Carousel';
import ArrowLeft from '../../assets/icons/arrow-left.svg';
import Shop from '../../assets/icons/shop.svg'

function SecondaryBanner({ slug }) {
    const [bannerImg, setBannerImg] = useState([]);
    const [contactInfo, setContactInfo] = useState([]);
    const carouselRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentX, setCurrentX] = useState(0);
    const [lastMoveTime, setLastMoveTime] = useState(0);

    // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
    const throttle = (func, delay) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= delay) {
                lastCall = now;
                func(...args);
            }
        };
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.clientX);
    };

    const handleMouseMove = throttle((e) => {
        if (!isDragging) return;

        setCurrentX(e.clientX);
    }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

    const handleMouseUp = () => {
        setIsDragging(false);
        const deltaX = currentX - startX;

        if (deltaX > 50) {
            if (carouselRef.current) {

                carouselRef.current.prev(); // اسلاید قبلی
            }
        } else if (deltaX < -50) {
            if (carouselRef.current) {

                carouselRef.current.next(); // اسلاید بعدی
            }

        }

        // ریست مقادیر
        setStartX(0);
        setCurrentX(0);
    };

    // جلوگیری از تغییر اسلاید هنگام کلیک روی دکمه‌ها
    const handleButtonClick = (e) => {
        e.stopPropagation(); // جلوگیری از پراپگیشن رویداد
    };
    const fetchContact = async () => {
        try {
            const pay = { pageSize: 0, pageIndex: 0 };
            const res = await getShopBySearch(pay);
            if (res.data.isSuccess) {
                const items = res.data.data.items;
                setContactInfo(items.filter((product) => product.title == 'منوی دیجیتال'));
            }
        } catch (error) {
            console.error('Error fetching Contact:', error);
        }
    };

    const loadPage = async () => {
        try {
            SearchBanner({ slug: slug }).then(response => {
                if (response.data) {
                    setBannerImg(response.data.data);

                }
            })
        } catch (error) { }
    };

    useEffect(() => {
        loadPage()
        if (slug == 'Product1') {
            fetchContact();
        }
    }, [])

    const videoRefs = useRef([]);

    const handleSlide = (eventKey) => {
        videoRefs.current.forEach((video, index) => {
            if (video) {
                if (index === eventKey) {
                    video.currentTime = 0; // بازنشانی زمان ویدیو
                    video.play(); // پخش مجدد ویدیو
                } else {
                    video.pause(); // توقف ویدیوهای دیگر
                }
            }
        });
    };
    return (
        <>
            {bannerImg.length > 0 && (
                <div className='slider web-slider container  pages secondary-slider' >
                    <div onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={() => setIsDragging(false)}
                        style={{ cursor: isDragging ? "grabbing" : "grab" }}>
                        <Carousel interval={10000} controls={false} ref={carouselRef} onSlide={handleSlide} indicators={bannerImg
                            .filter(item => item.useFor === 1).length > 1}>
                            {bannerImg.length && bannerImg
                                .filter(item => item.useFor === 1)
                                .sort((a, b) => a.number - b.number) // مرتب‌سازی بر اساس number
                                .map((item, index) => (
                                    <Carousel.Item key={`${item.fileId}-${index}`}> {/* اطمینان از unique بودن کلید */}

                                        {item.typeId == 2 ? (
                                            <div className="img-slider">
                                                <video
                                                    muted
                                                    ref={(el) => (videoRefs.current[index] = el)}
                                                    loop
                                                    style={{ width: '100%' }}
                                                    draggable={false}
                                                >
                                                    <source src={`${imgBaseUrl2}io/${item.filePath}`} type="video/mp4" />
                                                </video>
                                            </div>
                                        ) : (
                                            <img
                                                src={`${imgBaseUrl2}io/${item.filePath}`}
                                                className="img-slider"
                                                alt=""
                                                draggable={false}
                                            />
                                        )}
                                    </Carousel.Item>
                                ))}



                        </Carousel>
                    </div>

                    <div className='feature product-banner d-flex align-items-center justify-content-between !bottom-[-10px]' style={{
                        borderLeft: '1px solid #ececec',
                        borderTop: '1px solid #ececec', borderRight: '1px solid #ececec'
                    }}>
                        <div className='feature-left !bottom-[7px]'></div>
                        <div className='feature-right'></div>
                        {slug == 'Product1' ? (<>
                            <div>
                                <button
                                    className="btn btn-primary d-flex align-items-center gap-2 h-[48px]"
                                    onClick={() => { if (contactInfo) window.open(contactInfo[0].link, '_blank'); }}
                                >
                                    <img src={Shop} alt="Profile" />منوی دیجیتال
                                </button>
                            </div>
                        </>) : (

                            <>

                                <div className='text-center'>
                                    <img className='mx-auto' src={Ranking} alt="" />
                                    <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>دست ساز با بهترین مواد اولیه</h6>
                                </div>
                                <div className='text-center'>
                                    <img className='mx-auto' src={Task} alt="" />
                                    <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>ارگانیک دارای گواهی USDA</h6>
                                </div>
                                <div className='text-center'>
                                    <img className='mx-auto' src={Security} alt="" />
                                    <h6 className='text-base mt-2 font-bold text-[#3E3E3E]'>امن برای شما و خانواده شما</h6>
                                </div></>)}


                    </div>
                </div >
            )
            }


            <div className='slider mobile-slider pages'>

                <Carousel interval={10000} controls={false} indicators={bannerImg
                    .filter(item => item.useFor === 2).length > 1}>
                    {bannerImg.length && bannerImg
                        .filter(item => item.useFor === 2)
                        .sort((a, b) => a.number - b.number) // مرتب‌سازی بر اساس number
                        .map((item, index) => (
                            <Carousel.Item>
                                {item.typeId == 2 ? (
                                    <div className='img-slider h-full w-auto max-w-none'>
                                        <video
                                            muted
                                            ref={(el) => (videoRefs.current[index] = el)}
                                            loop
                                            style={{ width: '100%' }}

                                        >
                                            <source src={`${imgBaseUrl2}io/${item.filePath}`} type="video/mp4" />
                                        </video>
                                    </div>
                                ) : (
                                    <img
                                        src={`${imgBaseUrl2}io/${item.filePath}`}
                                        className='img-slider h-full w-auto max-w-none'
                                        alt=""
                                    />
                                )}


                            </Carousel.Item>
                        ))}


                </Carousel>
                <div className='feature product-banner d-flex align-items-center justify-content-between !bottom-[-7px]' style={{
                        borderLeft: '1px solid #ececec',
                        borderTop: '1px solid #ececec', borderRight: '1px solid #ececec'
                    }}>
                        <div className='feature-left !bottom-[7px]'></div>
                        <div className='feature-right'></div>
                    <>
                            <div>
                                <button
                                    className="btn btn-primary d-flex align-items-center gap-2 h-[48px]"
                                    onClick={() => { if (contactInfo) window.open(contactInfo[0].link, '_blank'); }}
                                >
                                    <img src={Shop} alt="Profile" />منوی دیجیتال
                                </button>
                            </div>
                        </>


                    </div>
            </div>
        </>
    )
}

export default SecondaryBanner;